import styled from 'styled-components'

export const ChangePasswordContainer = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin-top: 2rem;
  h4 {
    width: 100%;
  }

  > div {
    max-width: 300px;
    margin-right: 1rem;
  }
`
export const FormProfileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  > div {
    max-width: 400px;
    margin-right: 1rem;
  }
`

export const FormProfileWrapper = styled.div`
  padding: 2em;
`
export const CustomFormActions = styled.div`
  padding-bottom: 0;
`
